import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

//
// Converts newlines into html breaks
//
@Pipe({
  name: 'newline'
})

export class NewlinePipe implements PipeTransform {
  transform(value: string, args: string[]): any {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }
}

//
// Convert newlines to <p></p>
// Here a link for reference when we want to implement this:
// https://jsfiddle.net/CoryDanielson/aYwLg/ 
//
/*
@Pipe({
  name: 'newp'
})

export class NewpPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    return value;
  }
} 
*/ 

@Pipe({
  name: 'fileextension'
})

export class FileextensionPipe implements PipeTransform {
  transform(value: string): any {
    return value.split('.').pop();
  }
}

@Pipe({
  name: 'replace'
})

export class ReplacePipe implements PipeTransform {
  // value: string to modify
  // expr: string in which to search
  // replace: replacement string
  transform(value: string, expr: any, replace: string): any {
    if (!value)
      return value;

    return value.replace(new RegExp(expr, 'gi'), replace);
  }
}

/**
 * Generated class for the MomentjsPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'moment-from-now',
})
export class MomentFromNowPipe implements PipeTransform {
  /**
   * Takes a date value and returns a pretty string from current time, 
   * for instance: "four hours ago" or "in eleven minutes".
   */
  transform(value: string, ...args) {
    return moment(value).fromNow();
  }
}

@Pipe({
  name: 'moment_mysql_date',
})
export class MomentConvertMySqlPipe implements PipeTransform {
  /**
   * Takes a MySql date in the form YYYY-MM-DD and
   * converts it to MM/DD/YYYY
   */
  transform( value: string, ...args ) {
    if ( value === '0001-01-01' || value === '0000-00-00' || value === '' || typeof value === 'undefined' )
    {
      return '';
    }
    return moment(value).format('L');
  }
}

@Pipe({
  name: 'file_purpose',
})
export class FilePurposePipe implements PipeTransform {
  transform( value: string ) {
    switch ( value ) {
      case 'first_aid_card':
        return 'First Aid Card';
      case 'cpr_card':
        return 'CPR Card';
      case 'evidence_teaching_hours':
        return 'Evidence 30 Hours Teaching';
      case 'evidence_continuing_education':
        return 'Evidence 15 Hours CE';
      case 'proof_of_insurance':
        return 'Proof of Insurance';
      case 'odl':
        return 'Oregon Driver License';
      default:
        return 'User Uploaded File';
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/common-pipes.ts